import { OrderException, OrderItem } from '@usf/ngrx-order';
import {
  ErrorType,
  ExceptionType,
  RestrictedErrorCodes,
} from '../constants/order-exception-type.enum';

export interface MultiExceptionResolved {
  orderException: OrderException;
  orderItemIndexInOrder: number;
  resolvedItem: OrderItem;
  updateTimeStamp: string;
}

export function getExceptionType(
  errorType: string,
  errorCode: number,
): ExceptionType {
  switch (errorType) {
    case ErrorType.DATE:
      return ExceptionType.DATE;
    case ErrorType.PRICE:
      return ExceptionType.PRICE;
    case ErrorType.SUBSTITUTE:
      if (RestrictedErrorCodes.includes(errorCode)) {
        return ExceptionType.RESTRICTED;
      }
      return ExceptionType.OUT_OF_STOCK;
    case ErrorType.REPLACEMENT:
      return ExceptionType.PRODUCT_UNAVAILABLE;
    case ErrorType.QUANTITY:
      return ExceptionType.UNUSUAL_QUANTITY;
    case ErrorType.ACKNOWLEDGEMENT:
      return ExceptionType.ACKNOWLEDGEMENT;
    default:
      break;
  }
}
export function shouldRemoveSubbedOutOrderItem(
  productExceptions: MultiExceptionResolved[],
): boolean {
  const shouldRemoveOriginalOrderItem = new Set([
    ExceptionType.RESTRICTED,
    ExceptionType.OUT_OF_STOCK,
    ExceptionType.PRODUCT_UNAVAILABLE,
  ]);
  return productExceptions.some(exc =>
    shouldRemoveOriginalOrderItem.has(
      getExceptionType(
        exc.orderException.errorType,
        exc.orderException.errorCode,
      ),
    ),
  );
}
